import React, { FC } from 'react';

import { EvTag, EvTooltip, TAG_STATUS } from '@evinced-private/ui-common';

import { IProperty } from '../../../../interfaces/Property';

interface CollectionsPropertiesCellTagProps {
	property: IProperty;
	showEllipsisLength?: number;
}

export const CollectionsPropertiesCellTag: FC<CollectionsPropertiesCellTagProps> = ({
	property,
	showEllipsisLength = 15
}) => {
	const showTooltip = property?.name.length > showEllipsisLength;

	return (
		<div>
			<EvTag
				status={TAG_STATUS.INFO}
				text={property?.name ?? property.id}
				maxChars={showEllipsisLength}
			/>
			{showTooltip && <EvTooltip id={property.id} place="bottom" type="info" />}
		</div>
	);
};
